export default {
  brand: 'Basetao Spreadsheet',
  nav: {
    home: 'Startseite',
    guide: 'Einkaufsführer',
    categories: 'Kategorien',
  },
  buttons: {
    basetaoSpreadsheet: 'Basetao Spreadsheet',
    buyNow: 'Jetzt kaufen',
    readGuide: 'Guide lesen',
    visitMainSite: 'Hauptwebsite besuchen',
    browseCategories: 'Kategorien durchsuchen',
  },
  lang: {
    label: 'Sprache',
    english: 'English',
    french: 'Français',
    german: 'Deutsch',
    spanish: 'Español',
    portuguese: 'Português',
  },
  footer: {
    tagline: 'Ihre unabhängige Basetao Spreadsheet Ressource.',
    disclaimer:
      'Diese Website ist eine unabhängige Informationsressource und nicht die offizielle Basetao-Website, sofern nicht ausdrücklich anders angegeben.',
    categoriesTitle: 'Kategorien',
    resourcesTitle: 'Ressourcen',
    guideLink: 'Basetao Spreadsheet Guide',
    mainSiteLink: 'Hauptwebsite',
    rights: 'Alle Rechte vorbehalten.',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    desc: 'Die gesuchte Seite wurde möglicherweise verschoben oder existiert nicht mehr. Kehren Sie zur Startseite zurück oder besuchen Sie die Hauptwebsite.',
    backHome: 'Zur Startseite',
  },
};